import currency from "currency.js";

export function formatCurrency(value: number, locale: string = "pt-BR", currency: string = "BRL") {
  if (isNaN(value)) {
    return new Intl.NumberFormat(locale, { style: "currency", currency: currency }).format(0);
  }

  const fixedValue = parseFloat(value.toFixed(2));
  return new Intl.NumberFormat(locale, { style: "currency", currency: currency }).format(
    fixedValue
  );
}

export function convertCurrencyToNumber(value: string | unknown): number {
  if (typeof value === "string") {
    // Substitua "R$" por "" e remova espaços em branco antes e depois do valor
    const numericValue = currency(value.replace("R$", "").trim()).value;
    // Garante que o resultado é um número antes de retornar
    return typeof numericValue === "number" ? numericValue : 0;
  }

  // Retorna 0 se o valor não for uma string
  return 0;
}

export const formatPercentage = (value: number): string => {
  return `${value.toFixed(2)}%`;
};

export const formatInteger = (value: number): string => {
  return value.toString();
};
